<template>
  <div class="shareholder-info">
    <div class="field">
      <label>Name</label>
      <span class="bold">{{ shareholder.name }}</span>
    </div>
    <div class="field">
      <label>Registration #</label>
      <span class="bold">{{ shareholder.shn }}</span>
    </div>
    <div class="field">
      <label>Total Shares</label>
      <span class="bold">{{ shareholder.shares }}</span>
    </div>
    <div class="field">
      <label>Total Votes Available</label>
      <span class="bold">{{ (shareholder.shares || 0) * shareValue }}</span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  component: { type: Object, required: true },
  shareholder: { type: Object, default: () => ({}) },
  mode: { type: String, default: 'vote' },
  form: { type: Object, default: null },
  shareValue: { type: Number, default: 2 },
})
</script>

<style scoped>
.shareholder-info {
  padding: 12px 16px;
  border: 1px solid var(--panel-border, #e6e6e6);
  border-radius: 6px;
  background: var(--panel-bg, #fafafa);
  color: var(--panel-text, inherit);

  .field {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 6px;
  }

  .field label {
    min-width: 180px;
    font-size: 0.9rem;
    color: var(--muted-text, #555);
  }

  .bold {
    font-weight: 700;
    font-size: 18px;
    color: #1679ca;
  }
}
</style>
